import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import 'bootstrap/scss/bootstrap.scss'
import './index.scss';

ReactDOM.render(<App />, document.getElementById('root'));

// Would work on this later
// serviceWorker.unregister();
